export default "__VITE_ASSET__Dxm1MOZQ__"